import React, { ReactNode } from "react";

// Updated interface for Modal Props
interface ModalProps {
  overLayOpacity: "sm" | "md" | "lg";
  open: boolean;
  children: ReactNode;
  onClose: () => void; // Function to call on overlay click
}

// Map for overLayOpacity values
const opacityValues: { [key: string]: number } = {
  sm: 0.3,
  md: 0.5,
  lg: 0.7,
};

/**
 * Modal Component
 * @param {ModalProps} props - The props for the Modal component.
 */
const Modal: React.FC<ModalProps> = ({
  overLayOpacity,
  open,
  children,
  onClose,
}) => {
  // Prevents modal content clicks from closing the modal
  const stopPropagation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div
      className={`fixed inset-0 backdrop-blur-sm min-h-full h-fit z-[110] ${
        open ? "" : "hidden"
      }`}
      style={{
        backgroundColor: `rgba(0, 0, 0, ${opacityValues[overLayOpacity]})`,
      }}
      onClick={onClose} // Overlay click clsetNavOpen(!navOpen)oses the modal
    >
      <div className="flex h-full items-center justify-center min-h-screen overflow-y-scroll">
        <div
          className="w-11/12 tablet:w-3/4 desktop:w-1/2 h-full flex items-center justify-center"
          onClick={stopPropagation} // Prevents click through to the overlay
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
